import { ErrorData } from "../component/error-message-popper";

type Listener = (error: ErrorData) => void;
type ActionCallback = () => void;

class ErrorService {
    private listeners: Listener[] = [];
    private actionCallback?: ActionCallback | null = null;

    subscribe(listener: Listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter((l) => l !== listener);
        };
    }

    showError(error: ErrorData) {
        this.listeners.forEach((listener) => listener(error));
    }

    setActionCallback(callback: ActionCallback | null) {
        this.actionCallback = callback;
    }

    executeAction() {
        if (this.actionCallback) {
            this.actionCallback();
            this.actionCallback = null;
        }
    }
}

const errorService = new ErrorService();
export default errorService;
